class VmHeader extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = {signal:this.controller.signal};
    const toggle = this.querySelector('.vm-menu-toggle');
    const menu = document.getElementById('VmMenu');
    const setOpen = open => {
      toggle?.setAttribute('aria-expanded',String(open));
      document.body.classList.toggle('vm-menu-open',open);
      if (open && menu && !menu.open) menu.showModal();
      if (!open && menu?.open) menu.close();
    };
    this.closeMenu = () => setOpen(false);
    toggle?.addEventListener('click',()=>setOpen(toggle.getAttribute('aria-expanded')!=='true'),options);
    menu?.querySelector('[data-vm-menu-close]')?.addEventListener('click',()=>setOpen(false),options);
    menu?.addEventListener('close',()=>{toggle?.setAttribute('aria-expanded','false');document.body.classList.remove('vm-menu-open');},options);
    menu?.addEventListener('click',event=>{if(event.target===menu){const r=menu.getBoundingClientRect();if(event.clientX>r.right)setOpen(false);}},options);
    menu?.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>setOpen(false),options));
    const desktop=matchMedia('(min-width: 750px)');
    desktop.addEventListener('change',event=>{if(event.matches)setOpen(false);},options);
    this.addEventListener('keydown',e=>{if(e.key==='Escape'){setOpen(false);toggle?.focus();}},options);
    this.querySelectorAll('.vm-nav a').forEach(a=>a.addEventListener('click',()=>setOpen(false),options));
    const updateScroll=()=>this.classList.toggle('vm-header--scrolled',window.scrollY>60);
    window.addEventListener('scroll',updateScroll,{...options,passive:true});updateScroll();
    this.setupStickyOffer();
    document.addEventListener('shopify:section:load',()=>this.setupStickyOffer(),options);
    const dialog=document.getElementById('VmSearch');
    this.querySelectorAll('[data-vm-dialog]').forEach(button=>button.addEventListener('click',()=>{setOpen(false);dialog?.showModal();},options));
    dialog?.querySelector('[data-vm-close]')?.addEventListener('click',()=>dialog.close(),options);
    dialog?.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}},options);
  }
  setupStickyOffer() {
    this.cleanupStickyOffer?.();
    const offer=document.querySelector('.shopify-section-group-header-group > .gm-quantity-offer');
    const headerSection=this.closest('.vm-header-section');
    if(!offer || !headerSection)return;
    const offerSection=offer.parentElement;
    const controller=new AbortController();
    const options={signal:controller.signal,passive:true};
    let frame=0;
    const update=()=>{
      frame=0;
      const headerTop=parseFloat(getComputedStyle(headerSection).top)||0;
      const headerBottom=Math.max(0,this.getBoundingClientRect().bottom);
      const height=offer.getBoundingClientRect().height;
      const pinned=height>0 && window.scrollY>60 && headerSection.getBoundingClientRect().top<=headerTop+.5;
      if(pinned){
        offerSection.style.height=`${height}px`;
        offer.style.setProperty('--gm-sticky-offer-top',`${headerBottom}px`);
      }
      offer.classList.toggle('gm-quantity-offer--pinned',pinned);
      if(!pinned){
        offerSection.style.removeProperty('height');
        offer.style.removeProperty('--gm-sticky-offer-top');
      }
      document.documentElement.style.setProperty('--gm-sticky-stack-bottom',`${pinned ? headerBottom+height : 0}px`);
    };
    const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
    const observer=new ResizeObserver(schedule);
    observer.observe(this);
    observer.observe(offer);
    window.addEventListener('scroll',schedule,options);
    window.addEventListener('resize',schedule,options);
    this.cleanupStickyOffer=()=>{
      controller.abort();
      observer.disconnect();
      cancelAnimationFrame(frame);
      offer.classList.remove('gm-quantity-offer--pinned');
      offerSection.style.removeProperty('height');
      offer.style.removeProperty('--gm-sticky-offer-top');
      document.documentElement.style.removeProperty('--gm-sticky-stack-bottom');
    };
    update();
  }
  disconnectedCallback(){this.cleanupStickyOffer?.();this.closeMenu?.();this.controller?.abort();}
}
if(!customElements.get('vm-header'))customElements.define('vm-header',VmHeader);

const footerDesktop = matchMedia('(min-width: 750px)');
const updateFooterGroups = () => document.querySelectorAll('.vm-footer__group').forEach(group => { group.open = footerDesktop.matches; });
footerDesktop.addEventListener('change', updateFooterGroups);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateFooterGroups, {once:true});
else updateFooterGroups();
document.addEventListener('shopify:section:load', updateFooterGroups);

// Keep active filters when the separate mobile sorting control changes.
document.addEventListener('change', event => {
  if (!event.target.matches('[data-vm-collection-sort]')) return;
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', event.target.value);
  url.searchParams.delete('page');
  window.location.assign(url.toString());
});
